import { IconHome } from '@/components/Icon/HeaderIcon'
import { useRouterBack } from '@/hooks/useRouterBack'
import { IconBack } from '@/styles/Icon'
import Link from 'next/link'

const StickyPage = ({title}:{title: string}) => {
  const handleGoBack = useRouterBack()
    return (
        <div
            className={`sticky bg-[#FF0000] top-0 z-[999] flex h-[60px] w-full max-w-[440px] items-center justify-between`}
        >
            <div className='flex h-[60px] items-center justify-between px-1 w-full'>
            <div className='flex-[40px] max-w-[40px]'>
                <button
                className='h-10 w-10 outline-none flex justify-center items-center'
                onClick={() => handleGoBack(true)}
                >
                <IconBack color='#FFFFFF'/>
                </button>
            </div>

            <div className='flex-1 w-full px-1'>
                <h1 className='text-lg font-bold break-all text-[#FFF] overflow-hidden text-ellipsis  line-clamp-1'>
                {title}
                </h1>
            </div>
            <div className='flex-[40px] max-w-[40px]'>
                <Link
                className='h-10 w-10 outline-none flex justify-center items-center'
                href={'/'}
                >
                <IconHome color='#FFFFFF' />
                </Link>
            </div>
            </div>
        </div>
    )
}

export default StickyPage